module.exports = __webpack_public_path__ + "static/media/live14_12_2024.f1a8492d.jpg";